import { FormattedMessage } from 'react-intl'
import Chip from '@mui/material/Chip'

const getStatusColor = (status) => {
  switch (status) {
    case 'imported':
      return 'success'
    case 'pending':
      return 'warning'
    case 'failed':
      return 'error'
    default:
      return 'default'
  }
}

function PackageImportStatusChip({ packageImport }) {
  if (packageImport.pendingChanges) {
    return (
      <Chip
        label={<FormattedMessage id="packageImports.status.pendingChanges" />}
        size="small"
        sx={{ bgcolor: 'pendingChanges.main', color: 'pendingChanges.contrastText' }}
      />
    )
  }

  return (
    <Chip
      label={<FormattedMessage id={`packageImports.status.${packageImport.status}`} />}
      color={getStatusColor(packageImport.status)}
      size="small"
    />
  )
}

export default PackageImportStatusChip
